<div class="contact-person">
  @if (contact?.avatar?.resource) {
  <div [style]="avatarStyle" class="avatar"></div>
  } @if (!contact?.avatar?.resource) {
  <img src="assets/profile-placeholder.svg" [alt]="contact | ContactName" class="avatar placeholder" />
  }
  <div>
    @if (contact && isContributor(contact)) {
    <div class="contact-person__position">
      {{ contact.contributor_role }}
    </div>
    } @if (contactLink) {
    <a class="contact-person__link" [routerLink]="contactClickable ? contactLink : []">
      <ng-container *ngTemplateOutlet="contactPersonName"></ng-container>
    </a>
    } @else {
    {{ contact | ContactName }}
    }
    <ng-template #contactPersonName>
      {{ contact | ContactName }}
    </ng-template>
    @if (contact?.roles?.length) {
    <div class="contact-person__role">
      {{ (contact?.roles ?? []).join(', ') }}
    </div>
    } @if (contact?.mobile && index) {
    <a
      class="contact-person__link"
      [href]="'tel:' + contact?.mobile"
      (click)="
        trackContactClick.emit({
          element: $event.currentTarget,
          linkText: contact?.mobile,
          linkType: 'MOBILE_CONTACT_PERSON',
          contactPersonId: contact?.id
        })
      "
      (middleclick)="
        trackContactClick.emit({
          element: $event.currentTarget,
          linkText: contact?.mobile,
          linkType: 'MOBILE_CONTACT_PERSON',
          contactPersonId: contact?.id
        })
      ">
      <mat-icon>phone</mat-icon>
      {{ contact?.mobile }}</a
    >
    } @if (!contact?.mobile && contact?.phone && index) {
    <a
      class="contact-person__link"
      [href]="'tel:' + contact?.phone"
      (click)="
        trackContactClick.emit({
          element: $event.currentTarget,
          linkText: contact?.phone,
          linkType: 'TELEPHONE_CONTACT_PERSON',
          contactPersonId: contact?.id
        })
      "
      (middleclick)="
        trackContactClick.emit({
          element: $event.currentTarget,
          linkText: contact?.phone,
          linkType: 'TELEPHONE_CONTACT_PERSON',
          contactPersonId: contact?.id
        })
      ">
      <mat-icon>phone</mat-icon>
      {{ contact?.phone }}</a
    >
    } @if (contact?.email && index) {
    <a
      class="contact-person__link"
      [href]="'mailto:' + contact?.email"
      (click)="
        trackContactClick.emit({
          element: $event.currentTarget,
          linkText: contact?.email,
          linkType: 'MAIL_CONTACT_PERSON',
          contactPersonId: contact?.id
        })
      "
      (middleclick)="
        trackContactClick.emit({
          element: $event.currentTarget,
          linkText: contact?.email,
          linkType: 'MAIL_CONTACT_PERSON',
          contactPersonId: contact?.id
        })
      ">
      <mat-icon>mail</mat-icon>
      {{ size === 'phone' ? writeEmailText : contact?.email }}</a
    >
    }
  </div>
</div>
